import { Icon, useTheme } from '@web-chat-core/ui-kit';
import { LocalParticipant } from 'livekit-client';
import { useTranslation } from 'react-i18next';
import { useRaiseHand } from 'features/RaiseHand/hooks/useRaiseHand';
import { ControlButton } from 'ui/components/ControlButton/ControlButton';

export interface RaiseHandButtonProps {
    participant: LocalParticipant;
}

export const RaiseHandButton = ({ participant }: RaiseHandButtonProps) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { checkIsHandRaised, toggleRaiseHand } = useRaiseHand();
    const isHandRaised = checkIsHandRaised(participant);
    const title = isHandRaised ? t('web_call_put_hand') : t('web_call_raise_hand');
    const color = isHandRaised ? theme.root.colors.basicColors.inverted['90%'] : theme.root.colors.basicColors['90%'];

    const handleClick = () => {
        toggleRaiseHand(participant);
    };

    return (
        <ControlButton active={!isHandRaised} title={title} onClick={handleClick}>
            <Icon icon="icHandUp" color={color} size={24} />
        </ControlButton>
    );
};
